module.exports = __webpack_public_path__ + "static/media/sigla.1d59bf71.png";